module.exports = __webpack_public_path__ + "img/11.fbdbc2d7.png";